import styled from 'styled-components'

const Svg = styled.svg`
  display: inline-block;
  vertical-align: middle;
  width: 0.8em;
  margin: -0.4em 0.2em -0.3em -0.2em;
`

export const TickIcon = () => (
  <Svg viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.84734 9.44958L0.922852 5.31529L2.32956 4.1343L5.96473 7.18282L5.84734 7.08677L14.2886 0L15.6953 1.18099L7.25405 8.2686L5.84833 9.44875L5.84734 9.44958Z"
      fill="currentColor"
    />
  </Svg>
)
